import Rioglyph from '@rio-cloud/rio-uikit/Rioglyph';
import { uniq } from 'es-toolkit';
import { FormattedMessage } from 'react-intl';
import { BulkStatusError, BulkStatusErrorMessage } from './BulkStatusErrorMessage';
import { ReactNode } from 'react';

type BulkUpdateValidationFeedbackProps = {
    readonly validItemsCount: number;
    readonly invalidItems: readonly BulkStatusError[];
    readonly requestError?: ReactNode;
};

export const BulkUpdateValidationFeedback = ({
    requestError,
    validItemsCount,
    invalidItems,
}: BulkUpdateValidationFeedbackProps) => {
    const uniqueInvalidItemCount = uniq(invalidItems.flatMap((error) => error.identifiers)).length;
    const totalItemsCount = validItemsCount + uniqueInvalidItemCount;

    const feedbackMessage =
        validItemsCount > 0 ? (
            <FormattedMessage
                id="outboundOrderBook.transportAssignments.bulkUpdate.validationFeedback.successCount"
                values={{ successCount: validItemsCount, totalCount: totalItemsCount }}
            />
        ) : (
            <FormattedMessage id="outboundOrderBook.transportAssignments.bulkUpdate.validationFeedback.failure" />
        );

    const iconConfig = requestError
        ? { icon: 'rioglyph-remove-sign', iconClassName: 'text-color-danger' }
        : { icon: 'rioglyph-check-badge', iconClassName: 'text-color-success' };

    return (
        <div className="min-height-300 display-flex flex-column justify-content-center align-items-center gap-20">
            <div className="text-size-16">
                <FormattedMessage id="outboundOrderBook.transportAssignments.bulkUpdate.validationFeedback.title" />
            </div>
            <div>
                <Rioglyph icon={iconConfig.icon} iconClassName={iconConfig.iconClassName} size="h1" />
            </div>
            {requestError ? (
                requestError
            ) : (
                <>
                    <div>{feedbackMessage}</div>
                    {invalidItems.length > 0 && <BulkStatusErrorMessage errors={invalidItems} />}
                </>
            )}
        </div>
    );
};
